/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function StarOnIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M22.263 5.124A1.92 1.92 0 0 0 20.513 4c-.813 0-1.5.437-1.813 1.124l-4.001 8.305-9.002 1.312a2.04 2.04 0 0 0-1.626 1.374c-.187.687 0 1.498.5 1.998l6.502 6.432-1.5 9.117a1.96 1.96 0 0 0 .812 1.936c.625.5 1.438.5 2.063.187l8.065-4.309 8.001 4.31c.688.311 1.5.311 2.126-.188a1.96 1.96 0 0 0 .813-1.936l-1.563-9.117 6.501-6.432c.563-.5.75-1.311.5-1.998a2.04 2.04 0 0 0-1.625-1.374l-8.94-1.312z"/>}
        </IconWrapper>);
}
